import { useState } from "react";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { MdContentCopy, MdRefresh } from "react-icons/md";
import { RiShieldKeyholeLine } from "react-icons/ri";

import { signInUser, JwtReValidate } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";
import axios from "axios";

const ApiKeySettings = () => {
  const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
  const user = signInUser();
  const { aamarId, storeSettings, warehouse } = user;
  const { apiKeySettings } = storeSettings?.eCommerce || {};
  const lang = useSelector((state) => state.languageReducer);
  const [copied, setCopied] = useState(false);
  const [api, setApi] = useState(apiKeySettings?.key || "");

  const [isQueryTriggered, setIsQueryTriggered] = useState(apiKeySettings?.key !== ""); // Track if query is triggered


  const handleRegenerateKey =async () => {
    if (aamarId !== "" && apiKeySettings?.key === "") {
      setIsQueryTriggered(true)
      const generateKey = await axios.get(`${BASE_URL}ecom/generateKey/${aamarId}`)
      if(generateKey.data){
        console.log(generateKey.data)
        setApi(generateKey.data.apiKey)
        notify(generateKey.data.message, "success");
        setIsQueryTriggered(false)
        JwtReValidate()
      }else{
        notify("Api Key already exist", "success");
        setIsQueryTriggered(false)
      }
    }
  };

  return (
    <div>
        <div className="mb-4">
          <h5 className="d-flex align-items-center gap-2">
            <RiShieldKeyholeLine size={25} /> E-Commerce API Keys
          </h5>
          <hr />
          <div className="card p-3 mb-3">
            <div className="row mb-3">
              <div className="col-md-12">
                <label className="form-label">API Key</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={api}
                    readOnly
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={()=>handleRegenerateKey()}
                    disabled={isQueryTriggered}
                    title="Generate new API key"
                  >
                    <MdRefresh />
                  </button>
                  <CopyToClipboard
                    text={api}
                    onCopy={() => {
                      setCopied(true);
                      notify("API Key copied to clipboard!", "success");
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      title="Copy to clipboard"
                    >
                      <MdContentCopy />
                    </button>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default ApiKeySettings;